import { render, staticRenderFns } from "./ui-video-control.vue?vue&type=template&id=47660a11&scoped=true"
import script from "./ui-video-control.vue?vue&type=script&lang=ts"
export * from "./ui-video-control.vue?vue&type=script&lang=ts"
import style0 from "./ui-video-control.vue?vue&type=style&index=0&id=47660a11&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47660a11",
  null
  
)

export default component.exports